// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"329":"c625718eba454ca3","8402":"36d7e23b249f7b85"}[chunkId] + ".css";
};